/** Default and per-section SEO copy for abc777 (slots, fishing, Shan Koe Mee, Bugyi, live casino, card games). */

/** Protocol + host (no trailing slash). Uses the live URL so one build works on abc777.biz, .cc, .tel, etc. */
export function getSiteOrigin() {
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return window.location.origin;
  }
  return '';
}

/**
 * Absolute canonical URL for a route pathname (must match router SEO / index.html bootstrap).
 * @param {string} [path] pathname e.g. /home (query/hash ignored)
 */
export function getCanonicalUrlForPath(path) {
  const pathname = ((path || '/').split('?')[0] || '/').replace(/\/+$/, '') || '/';
  const origin = getSiteOrigin();
  if (!origin) return '';
  return pathname === '/' ? origin : `${origin}${pathname}`;
}

const BASE_DESC =
  'abc777 offers online slots, fishing arcade games, Shan Koe Mee (Shan poker), Bugyi and classic card games, plus live casino with real dealers. Play securely, fast deposits and withdrawals, promotions for Myanmar players.';

const BASE_KEYWORDS =
  'abc777, online slots, slot games, fishing game, fishing arcade, Shan Koe Mee, Shan poker, ဘူဂျီ, Bugyi, Bugyee, online card games, live casino, live dealer, baccarat, roulette, Myanmar online casino, jackpot slots';

export const siteDefaults = {
  title: 'abc777 | Online Slots, Fishing, Shan Koe Mee, Bugyi, Live Casino & Card Games',
  description: BASE_DESC,
  keywords: BASE_KEYWORDS,
};

export const pageMeta = {
  home: siteDefaults,

  slots: {
    title: 'Online Slot Games | abc777 — Jackpots & Popular Slots',
    description:
      'Play hundreds of online slot games at abc777: classic reels, video slots, jackpots and bonus features. Fast play, fair results, mobile-friendly.',
    keywords: `${BASE_KEYWORDS}, video slots, jackpot slots, slot bonus`,
  },

  fishing: {
    title: 'Fishing Arcade Games Online | abc777',
    description:
      'Shoot-and-catch fishing arcade games at abc777. Colorful tables, multipliers and real-time action—popular in Myanmar and Southeast Asia.',
    keywords: `${BASE_KEYWORDS}, fishing shooter game, arcade fishing`,
  },

  liveCasino: {
    title: 'Live Casino & Live Dealer Games | abc777',
    description:
      'Live casino at abc777: real dealers, HD streams, baccarat, roulette and more. Feel like a real casino floor from your phone or desktop.',
    keywords: `${BASE_KEYWORDS}, live baccarat, live roulette, HD casino stream`,
  },

  shanKoeMee: {
    title: 'Shan Koe Mee Online Rooms | abc777',
    description:
      'Join Shan Koe Mee (Shan poker) tables at abc777. Play with friends or match online—authentic card rules and smooth gameplay.',
    keywords: `${BASE_KEYWORDS}, Shan Koe Mee room, Shan poker online`,
  },

  bugyee: {
    title: 'Bugyi (Bugyee) Card Game Online | abc777',
    description:
      'Play Bugyi / Bugyee card games online at abc777. Traditional Myanmar-style card play with reliable tables and quick rounds.',
    keywords: `${BASE_KEYWORDS}, Bugyi online, Bugyee card game`,
  },

  cardGames: {
    title: 'Online Card Games & Tables | abc777',
    description:
      'Card games and table games at abc777 alongside slots and live casino. One account for multiple game types.',
    keywords: `${BASE_KEYWORDS}, table games, multiplayer cards`,
  },

  arcade: {
    title: 'Arcade & Casual Games | abc777',
    description: 'Arcade and casual games at abc777—quick fun between slots, fishing and live casino sessions.',
    keywords: `${BASE_KEYWORDS}, arcade games online`,
  },

  promotion: {
    title: 'Casino Promotions & Bonuses | abc777',
    description:
      'Latest abc777 promotions: welcome offers, reload bonuses and cashback for slots, live casino and card games. Check terms on each offer.',
    keywords: `${BASE_KEYWORDS}, casino bonus, welcome bonus, cashback`,
  },

  login: {
    title: 'Member Login | abc777',
    description: 'Log in to your abc777 account to play slots, fishing, Shan Koe Mee, Bugyi, live casino and card games.',
    keywords: `${BASE_KEYWORDS}, abc777 login`,
  },

  register: {
    title: 'Register & Join | abc777',
    description:
      'Create a abc777 account in minutes. Access slots, fishing games, Shan Koe Mee, Bugyi, live casino and secure banking.',
    keywords: `${BASE_KEYWORDS}, abc777 register, sign up`,
  },

  contact: {
    title: 'Contact Us | abc777',
    description: 'Contact abc777 support for account, deposits, withdrawals and game questions.',
    keywords: `${BASE_KEYWORDS}, abc777 support, customer service`,
  },

  rule: {
    title: 'Rules & Terms | abc777',
    description: 'Rules, terms and responsible play information for abc777 members.',
    keywords: `${BASE_KEYWORDS}, terms and conditions`,
  },

  deposit: {
    title: 'Deposit | abc777',
    description: 'Deposit funds securely to play slots, fishing, live casino and card games at abc777.',
    keywords: `${BASE_KEYWORDS}, deposit`,
    robots: 'noindex, nofollow',
  },

  withdraw: {
    title: 'Withdraw | abc777',
    description: 'Withdraw your winnings from abc777 with supported payment methods.',
    keywords: `${BASE_KEYWORDS}, withdraw`,
    robots: 'noindex, nofollow',
  },

  banking: {
    title: 'Banking | abc777',
    description: 'Banking and payment options for abc777 members.',
    keywords: `${BASE_KEYWORDS}, banking`,
    robots: 'noindex, nofollow',
  },

  history: {
    title: 'Transaction History | abc777',
    description: 'View your abc777 transaction history.',
    robots: 'noindex, nofollow',
  },

  setting: {
    title: 'Account Settings | abc777',
    description: 'Manage your abc777 account settings.',
    robots: 'noindex, nofollow',
  },

  betslip: {
    title: 'Betslip History | abc777',
    description: 'Your betslip history at abc777.',
    robots: 'noindex, nofollow',
  },

  liveScore: {
    title: 'Live Score | abc777',
    description: 'Live scores and sports updates at abc777.',
    keywords: BASE_KEYWORDS,
  },

  matchResult: {
    title: 'Football Match Results | abc777',
    description: 'View today and yesterday football match results at abc777.',
    keywords: `${BASE_KEYWORDS}, football results, match results`,
  },

  maungFb: {
    title: 'Maung FB | abc777',
    description: 'Maung FB at abc777.',
    keywords: BASE_KEYWORDS,
  },

  bodyFb: {
    title: 'Body FB | abc777',
    description: 'Body FB at abc777.',
    keywords: BASE_KEYWORDS,
  },

  videoLinks: {
    title: 'Video Links | abc777',
    description: 'Video links and guides at abc777.',
    keywords: BASE_KEYWORDS,
  },

  commission: {
    title: 'Commission | abc777',
    description: 'Commission program at abc777.',
    robots: 'noindex, nofollow',
  },

  level: {
    title: 'VIP Levels | abc777',
    description: 'VIP levels and rewards at abc777.',
    keywords: `${BASE_KEYWORDS}, VIP`,
  },

  guides: {
    title: 'App Install Guide | abc777',
    description: 'Install the abc777 app on Android or iOS for slots, fishing, live casino and card games.',
    keywords: `${BASE_KEYWORDS}, abc777 app, install guide`,
  },

  androidGuide: {
    title: 'Android App Install | abc777 — Slots, Fishing & Live Casino',
    description:
      'Install abc777 on Android: play online slots, fishing games, Shan Koe Mee, Bugyi and live casino on your phone.',
    keywords: `${BASE_KEYWORDS}, abc777 Android APK`,
  },

  iosGuide: {
    title: 'iOS App Install | abc777 — Slots, Fishing & Live Casino',
    description:
      'Install abc777 on iPhone or iPad: slots, fishing arcade, card games and live dealer casino.',
    keywords: `${BASE_KEYWORDS}, abc777 iOS app`,
  },

  dreamBooks: {
    title: 'Dream Books | abc777',
    description: 'Dream books feature at abc777.',
    keywords: BASE_KEYWORDS,
  },

  twoD: {
    title: '2D | abc777',
    description: '2D games at abc777.',
    keywords: BASE_KEYWORDS,
  },

  threeD: {
    title: '3D | abc777',
    description: '3D games at abc777.',
    keywords: BASE_KEYWORDS,
  },

  landing: {
    title: 'abc777 — Slots, Fishing, Live Casino & Card Games',
    description: BASE_DESC,
    keywords: BASE_KEYWORDS,
  },

  iframe: {
    title: 'Game | abc777',
    robots: 'noindex, nofollow',
  },

  verify: {
    title: 'Verify Account | abc777',
    robots: 'noindex, nofollow',
  },

  dataTable: {
    title: 'Data | abc777',
    robots: 'noindex, nofollow',
  },
};
